var React = require('react');

function AppLogo (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.666626","y":"0.0200195","width":"72","height":"72","rx":"36","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25.9172 21.3535L36.6666 42.7567L47.416 21.3535L52.6666 49.2322L49.1653 49.8857L45.8663 32.3693L36.6666 50.6868L27.4669 32.3693L24.1679 49.8857L20.6666 49.2322L25.9172 21.3535Z","fill":"#0BC5EA","key":1})]);
}

AppLogo.defaultProps = {"width":"73","height":"73","viewBox":"0 0 73 73","fill":"none"};

module.exports = AppLogo;

AppLogo.default = AppLogo;
